/* eslint-disable*/
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { useSelector } from 'react-redux';

function ActionButton(props) {
  const [isOpen, setIsOpen] = useState(false);

  const { setActionPopUp } = props;
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div className="dropdown-container">
      <button
        className={`Active-btn ${isOpen ? 'active' : ''}`}
        onClick={handleClick}
      >
        Action
        <ArrowDropDownOutlinedIcon />
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <ul onClick={() => setActionPopUp(true)}>
            <li onClick={() => setIsOpen(false)}>
              {t.EDITPROFILE}
            </li>
            <li onClick={() => setIsOpen(false)}>{t.CHANGECHAT}</li>
            <li onClick={() => setIsOpen(false)}>
              {t.VIEWAGENT}
            </li>
            <li onClick={() => setIsOpen(false)}>{t.SUSPENSEAGENT}</li>
            <li onClick={() => setIsOpen(false)}>{t.DELETEALL}</li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default ActionButton;
